import React from 'react'

import { Form, Col } from '_zari/core'

import TiposConstant from 'constants/tipoPlantilla'

import { IdGen } from 'utils'

const TipoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-tipo' sm={3} md={4} alignRightAt='sm' />
      <Col sm={9} md={8}>
        <Form.Select id='select-tipo' name='select-tipo' value={value} onChange={onChange}>
          <option value=''>Seleccionar</option>
          {TiposConstant.__array.map(x => (
            <option key={IdGen.newId()} value={x.id}>
              {x.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default TipoFormGroup
